function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { reactive, toRefs, computed } from "vue";
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { ENERGY_CLASS } from "@customTypes/EnergyClass";
//@ts-ignore
import { isArrNullOrEmpty } from "@utils/ArrayUtils";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
export function usePlaceType() {
  var _this = this;
  var state = reactive({
    localityList: [],
    /**
     * The zone list resulting from the city search
     * */
    zoneList: [],
    searchBeanModal: getDefaultSearchBean(),
    prevSelectedLocality: undefined,
    //TODO: valutare se inserirlo solo in placeModal
    localitySelected: undefined,
    prevZoneIDsSelected: undefined,
    //TODO: valutare se inserirlo solo in placeModal
    /**
     * The zone ids checked (from the dropdown)
     * */
    zoneIDsSelected: [],
    zoneModifiedByUser: false,
    districtSelected: {},
    districtsObj: {},
    lastInsertedZone: 0
  });
  var isSingleDistrictSelected = computed(function () {
    return selectedDistrictLength.value === 1;
  });
  var isAnyDistrictSelected = computed(function () {
    return Object.keys(state.districtSelected).length > 0;
  });
  var selectedDistrictLength = computed(function () {
    return Object.values(state.districtSelected).reduce(function (prev, cur) {
      return prev + cur.length;
    }, 0);
  });
  var partialSelectedDistrictLength = computed(function () {
    return Object.entries(state.districtSelected).reduce(function (prev, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        zoneId = _ref2[0],
        districts = _ref2[1];
      var totalDistrictLength = getDistrictLengthByZoneId(+zoneId);
      if (totalDistrictLength === districts.length) return prev;
      return prev + districts.length;
    }, 0);
  });
  var allDistrictSelectedPerZone = computed(function () {
    if (!isAnyDistrictSelected.value) {
      return false;
    }
    for (var zoneId in state.districtSelected) {
      var districtSelectedLength = state.districtSelected[zoneId].length;
      var districtLength = state.districtsObj[zoneId].length;
      if (districtSelectedLength !== districtLength) return false;
    }
    return true;
  });
  var convertEnergyClassFilter = function convertEnergyClassFilter() {
    switch (state.searchBeanModal.energyClassFilter) {
      case "HIGH":
        {
          state.searchBeanModal.energyClassFilter = ENERGY_CLASS.HIGH;
          break;
        }
      case "MEDIUM":
        {
          state.searchBeanModal.energyClassFilter = ENERGY_CLASS.MEDIUM;
          break;
        }
      case "LOW":
        {
          state.searchBeanModal.energyClassFilter = ENERGY_CLASS.LOW;
          break;
        }
    }
  };
  var convertFloor = function convertFloor() {
    state.searchBeanModal.floor = state.searchBeanModal.floorId;
  };
  /* SearchBeanModal handling */
  var resetSearchBeanZonesAndLocalities = function resetSearchBeanZonesAndLocalities() {
    state.zoneList = [];
    state.zoneIDsSelected = [];
    state.districtSelected = {};
    state.localitySelected = undefined;
    state.searchBeanModal.zoneIdList = [];
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.districtIdList = [];
    state.searchBeanModal.zoneId = null;
    state.searchBeanModal.zoneURL = null;
    state.searchBeanModal.districtId = null;
    state.searchBeanModal.districtURL = null;
  };
  var updateSearchModal = function updateSearchModal(searchBean) {
    var _searchBean = deepCopy(searchBean);
    if (!_searchBean) throw new Error("_searchBean is null");
    state.searchBeanModal = _searchBean;
  };
  var updateSearchModalByPlace = function updateSearchModalByPlace(plc) {
    state.searchBeanModal.areaOfInterestId = plc.areaOfInterestID;
    state.searchBeanModal.cityURL = plc.cityURL;
    state.searchBeanModal.cityDisplayName = plc.displayName;
    state.searchBeanModal.cityId = plc.cityID;
    state.searchBeanModal.placeType = plc.placeType;
    state.searchBeanModal.placeId = plc.placeID;
    state.searchBeanModal.provinceId = plc.provinceID;
    state.searchBeanModal.regionId = plc.regionID;
    state.searchBeanModal.zoneId = plc.zoneID;
    state.searchBeanModal.zoneIdList = [];
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.polygonFromMap = "";
    state.searchBeanModal.polygonForDB = "";
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.zoneURL = plc.zoneURL;
    state.searchBeanModal.districtId = plc.districtID;
    //The zoneIDList is used to update the counter!
    if (plc.zoneID) state.searchBeanModal.zoneIdList = [plc.zoneID];
    //Same for the localityIdList!
    if (plc.localityID) state.searchBeanModal.localityIdList = [plc.localityID];
    if (plc.placeType === PLACE_TYPE.DISTRICT) {
      state.searchBeanModal.districtIdList = [plc.districtID];
      state.searchBeanModal.districtId = plc.districtID;
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.zoneIdList = [];
    }
  };
  var updateSearchModalAndPlace = function updateSearchModalAndPlace(plc, updatePlace) {
    updateSearchModalByPlace(plc);
    updatePlace();
  };
  var fixSearchBean = function fixSearchBean(updateZoneCb, updateLocationCb, updateDistrictCb) {
    var _state$searchBeanModa = state.searchBeanModal,
      localityIdList = _state$searchBeanModa.localityIdList,
      zoneIdList = _state$searchBeanModa.zoneIdList,
      districtIdList = _state$searchBeanModa.districtIdList;
    if (localityIdList && localityIdList.length) {
      state.searchBeanModal.localityIdList = _toConsumableArray(localityIdList);
      state.searchBeanModal.zoneURL = updateLocationCb();
      return;
    }
    if (zoneIdList) {
      if (zoneIdList.length == 1) {
        state.searchBeanModal.zoneId = zoneIdList[0];
        state.searchBeanModal.zoneIdList = [];
        state.searchBeanModal.zoneURL = updateZoneCb();
      } else if (zoneIdList.length > 1) {
        // remove duplicate IDS
        state.searchBeanModal.zoneIdList = _toConsumableArray(new Set(state.searchBeanModal.zoneIdList));
        state.searchBeanModal.zoneURL = null;
        state.searchBeanModal.zoneId = null;
      }
    } else if (districtIdList) {
      if (districtIdList.length == 1) {
        state.searchBeanModal.districtId = districtIdList[0];
        state.searchBeanModal.districtIdList = [];
        state.searchBeanModal.districtURL = updateDistrictCb();
      } else if (districtIdList.length > 1) {
        // remove duplicate IDS
        //state.searchBeanModal.districtIdList = [...new Set(state.searchBeanModal.districtIdList)];
        state.searchBeanModal.districtURL = null;
        state.searchBeanModal.districtId = null;
      }
    } else {
      state.searchBeanModal.zoneURL = null;
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.districtURL = null;
      state.searchBeanModal.districtId = null;
    }
  };
  /* Zone and Location handling */
  var initZonesAndLocalities = function initZonesAndLocalities(placesPromise) {
    var onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var onFailure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _a, places, localities, zones, selectedDistrictIds, _loop, _i, _zones;
      return _regeneratorRuntime().wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return placesPromise;
          case 2:
            places = _context2.sent;
            if (!places || places.length <= 0) {
              onFailure && onFailure();
              // throw new Error("empty or null places");
            }
            localities = [];
            zones = [];
            places.forEach(function (p) {
              if (p.zoneID) zones.push(p);else if (p.localityID) localities.push(p);
            });
            state.localityList = localities;
            state.zoneList = zones;
            selectedDistrictIds = 0;
            state.districtsObj = {};
            state.districtSelected = {};
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var zone;
              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    zone = _zones[_i];
                    if (!(zone.subPlaces.length <= 0)) {
                      _context.next = 3;
                      break;
                    }
                    return _context.abrupt("return", 1);
                  case 3:
                    // $set(state.districtsObj, zone.zoneID, zone.subPlaces)
                    state.districtsObj[zone.zoneID] = zone.subPlaces;
                    if (selectedDistrictIds < (((_a = state.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.length) || -1))
                      //Initializing districts selected
                      state.districtsObj[zone.zoneID].forEach(function (district) {
                        var _a;
                        if ((_a = state.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.includes(district.districtID)) {
                          insertDistrictByZoneId(zone.zoneID, district.districtID);
                          ++selectedDistrictIds;
                        }
                      });
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _loop);
            });
            _i = 0, _zones = zones;
          case 14:
            if (!(_i < _zones.length)) {
              _context2.next = 21;
              break;
            }
            return _context2.delegateYield(_loop(), "t0", 16);
          case 16:
            if (!_context2.t0) {
              _context2.next = 18;
              break;
            }
            return _context2.abrupt("continue", 18);
          case 18:
            _i++;
            _context2.next = 14;
            break;
          case 21:
            onSuccess && onSuccess();
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    }));
  };
  var areAllDistrictsSelected = function areAllDistrictsSelected(zoneId) {
    return state.zoneIDsSelected.includes(zoneId);
  };
  var isSingleDistrictByZoneId = function isSingleDistrictByZoneId(zoneId) {
    if (!state.districtSelected[zoneId]) return false;
    return state.districtSelected[zoneId].length === 1;
  };
  var isZoneOrLocalitySelected = function isZoneOrLocalitySelected() {
    return state.zoneIDsSelected.length > 0 || state.localitySelected != null;
  };
  var isZoneWithoutDistrict = function isZoneWithoutDistrict(zoneId) {
    return !Object.keys(state.districtsObj).includes("".concat(zoneId));
  };
  var areZonesAndLocalitiesEmpty = function areZonesAndLocalitiesEmpty() {
    return isArrNullOrEmpty(state.zoneList) && isArrNullOrEmpty(state.localityList);
  };
  var areZonesAndLocalitiesFilled = function areZonesAndLocalitiesFilled() {
    return !isArrNullOrEmpty(state.zoneList) && !isArrNullOrEmpty(state.localityList);
  };
  var getSingleSelectedZone = function getSingleSelectedZone() {
    if (state.zoneIDsSelected.length !== 1 && !state.searchBeanModal.zoneId) return null;
    var currentZoneID = state.zoneIDsSelected.length == 1 ? state.zoneIDsSelected[0] : state.searchBeanModal.zoneId;
    return getZoneById(currentZoneID);
  };
  var getSingleSelectedDistrict = function getSingleSelectedDistrict() {
    var _a;
    if (Object.keys(state.districtSelected).length !== 1 && (((_a = state.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.length) !== 1 || !state.searchBeanModal.districtId)) return null;
    var districtSelectedKeys = Object.keys(state.districtSelected);
    var singleZoneId = districtSelectedKeys[0];
    return getDistrictById(+singleZoneId, Object.values(state.districtSelected)[0][0]);
  };
  var getZoneById = function getZoneById(zoneID) {
    if (!zoneID) return null;
    var _iterator = _createForOfIteratorHelper(state.zoneList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var plc = _step.value;
        if (plc.zoneID === zoneID) {
          return plc;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return null;
  };
  var getDistrictById = function getDistrictById(zoneId, districtID) {
    if (!districtID || !zoneId) {
      return null;
    }
    var _iterator2 = _createForOfIteratorHelper(state.districtsObj[zoneId]),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var plc = _step2.value;
        if (plc.districtID === districtID) {
          return plc;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return null;
  };
  var getDistrictLengthByZoneId = function getDistrictLengthByZoneId(zoneId) {
    return state.districtsObj[zoneId].length;
  };
  var getDistrictSelectedLengthByZoneId = function getDistrictSelectedLengthByZoneId(zoneId) {
    if (!state.districtSelected[zoneId]) return null;
    return state.districtSelected[zoneId].length;
  };
  var resetZoneAndLocalities = function resetZoneAndLocalities() {
    if (isArrNullOrEmpty(state.zoneList) && isArrNullOrEmpty(state.localityList)) {
      return;
    }
    state.zoneList = [];
    state.localityList = [];
  };
  var addZone = function addZone(zone, updatePlaceNameAction) {
    state.zoneIDsSelected = [].concat(_toConsumableArray(state.zoneIDsSelected), [zone.zoneID]);
    state.lastInsertedZone = zone.zoneID;
    addDistrict(zone, updatePlaceNameAction);
    if (state.searchBeanModal.zoneIdList) state.searchBeanModal.zoneIdList = [].concat(_toConsumableArray(state.searchBeanModal.zoneIdList), [zone.zoneID]);
    state.zoneModifiedByUser = true;
    if (state.zoneIDsSelected.length === 1) {
      state.searchBeanModal.zoneURL = zone.zoneURL;
      state.searchBeanModal.zoneId = zone.zoneID;
    } else {
      state.searchBeanModal.zoneURL = null;
      state.searchBeanModal.zoneId = null;
    }
    updatePlaceNameAction();
  };
  var removeZone = function removeZone(zone, updatePlaceNameAction) {
    var isDistrict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _a, _b;
    state.zoneIDsSelected = state.zoneIDsSelected.filter(function (id) {
      return id !== zone.zoneID;
    }) || [];
    if (!isDistrict) removeDistrict(zone, updatePlaceNameAction);
    state.searchBeanModal.zoneIdList = ((_b = (_a = state.searchBeanModal) === null || _a === void 0 ? void 0 : _a.zoneIdList) === null || _b === void 0 ? void 0 : _b.filter(function (id) {
      return id !== zone.zoneID;
    })) || [];
    state.searchBeanModal.zoneId = null;
    state.searchBeanModal.zoneURL = null;
    state.zoneModifiedByUser = true;
    if (state.zoneIDsSelected.length === 1) {
      var singleZone = state.zoneList.find(function (z) {
        return z.zoneID === state.zoneIDsSelected[0];
      });
      if (singleZone) {
        state.searchBeanModal.zoneURL = singleZone.zoneURL;
        state.searchBeanModal.zoneId = singleZone.zoneID;
      }
    }
    updatePlaceNameAction();
  };
  var isZoneSelected = function isZoneSelected(zoneId) {
    var _a;
    return state.zoneIDsSelected.includes(zoneId) || !!((_a = state.districtsObj[zoneId]) === null || _a === void 0 ? void 0 : _a.find(function (district) {
      var _a;
      return (_a = state.districtSelected[zoneId]) === null || _a === void 0 ? void 0 : _a.includes(district.districtID);
    }));
  };
  var isLocationSelected = function isLocationSelected(locationId) {
    var _a;
    return ((_a = state.localitySelected) === null || _a === void 0 ? void 0 : _a.localityID) === locationId;
  };
  var isDistrictSelected = function isDistrictSelected(zoneId, districtId) {
    if (!state.districtSelected[zoneId]) return false;
    return state.districtSelected[zoneId].includes(districtId);
  };
  /**
   * Add a single location to the zoneIdSelected list.
   * This method ensures that the zoneIdSelected list will contain ONLY the locationId passed as input parameter
   * */
  var addLocation = function addLocation(place, updatePlaceNameAction) {
    state.zoneIDsSelected = [];
    state.searchBeanModal.zoneIdList = [];
    /*
            if(state.localitySelected !== undefined)
                $set(state.localitySelected, "localitySelected", place as Place)*/
    state.localitySelected = place;
    if (state.searchBeanModal) {
      state.searchBeanModal.localityIdList = [place.localityID];
      state.searchBeanModal.zoneURL = place.zoneURL;
    }
    state.zoneModifiedByUser = true;
    updatePlaceNameAction();
  };
  var removeLocation = function removeLocation(updatePlaceNameAction) {
    state.localitySelected = undefined;
    state.searchBeanModal.localityIdList = [];
    state.searchBeanModal.zoneURL = "";
    state.zoneModifiedByUser = true;
    updatePlaceNameAction();
  };
  var insertDistrictByZoneId = function insertDistrictByZoneId(zoneId, districtId) {
    if (!state.districtSelected[zoneId]) {
      // $set(state.districtSelected, `${zoneId}`, [districtId])
      state.districtSelected[zoneId] = [districtId];
    } else {
      state.districtSelected[zoneId] = [].concat(_toConsumableArray(state.districtSelected[zoneId]), [districtId]);
    }
  };
  var insertBulkDistrictByZoneId = function insertBulkDistrictByZoneId(zoneId, districtId) {
    // $set(state.districtSelected, `${zoneId}`, districtId)
    state.districtSelected[zoneId] = districtId;
  };
  var onPlaceLIClick = function onPlaceLIClick(place, updatePlaceNameAction) {
    var isLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    //Sebastian R.S: If we select a zone, we want to remove the ONLY selected locality if present
    if (place.zoneID && state.localitySelected) removeLocation(updatePlaceNameAction);
    if (isLocation) addLocation(place, updatePlaceNameAction);else {
      isZoneSelected(place.zoneID) ? removeZone(place, updatePlaceNameAction) : addZone(place, updatePlaceNameAction);
    }
  };
  var onDistrictClick = function onDistrictClick(zone, district, updatePlaceNameAction) {
    state.lastInsertedZone = zone.zoneID;
    if (isDistrictSelected(district.zoneID, district.districtID) || areAllDistrictsSelected(zone.zoneID)) removeDistrict(zone, updatePlaceNameAction, district);else addDistrict(zone, updatePlaceNameAction, district);
  };
  var addDistrict = function addDistrict(zone, updatePlaceNameAction, district) {
    var _a, _b, _c, _d, _e, _f;
    if (!district) {
      return;
    }
    //Cleaning up the zoneUrl
    state.searchBeanModal.zoneURL = null;
    state.searchBeanModal.zoneId = null;
    //If almost all the districts are selected, before the insert of the current district...
    if (getDistrictLengthByZoneId(zone.zoneID) - 1 === ((_a = state.districtSelected[zone.zoneID]) === null || _a === void 0 ? void 0 : _a.length)) {
      addZone(zone, updatePlaceNameAction);
      if (!state.searchBeanModal.districtIdList) return;
      //Removing all the districts previously selected for the specific zone
      state.searchBeanModal.districtIdList = state.searchBeanModal.districtIdList.filter(function (districtID) {
        return !state.districtsObj[zone.zoneID].find(function (district) {
          return district.districtID == districtID;
        });
      });
      //Removing the zoneId and its districts from districtSelected
      // $delete(state.districtSelected, zone.zoneID)
      delete state.districtSelected[zone.zoneID];
    }
    //In any other scenario, we will normally add the districts
    else {
      //By default, we remove the zoneId of the district from the searchBeanModal
      var zoneIdxToRemove = (_b = state.searchBeanModal.zoneIdList) === null || _b === void 0 ? void 0 : _b.findIndex(function (zoneId) {
        return zoneId === zone.zoneID;
      });
      if (zoneIdxToRemove !== -1 && zoneIdxToRemove !== undefined) (_c = state.searchBeanModal.zoneIdList) === null || _c === void 0 ? void 0 : _c.splice(zoneIdxToRemove, 1);
      insertDistrictByZoneId(zone.zoneID, district.districtID);
      if (state.searchBeanModal.districtIdList) state.searchBeanModal.districtIdList = [].concat(_toConsumableArray(state.searchBeanModal.districtIdList), [district.districtID]);
    }
    //Case single district
    if (((_d = state.searchBeanModal.districtIdList) === null || _d === void 0 ? void 0 : _d.length) === 1 && !((_e = state.searchBeanModal.zoneIdList) === null || _e === void 0 ? void 0 : _e.length)) {
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.zoneURL = null;
      state.searchBeanModal.zoneIdList = [];
    }
    if (state.searchBeanModal.zoneIdList && state.searchBeanModal.zoneIdList.length === 1) {
      // @ts-ignore
      state.searchBeanModal.zoneURL = (_f = state.zoneList.find(function (z) {
        return z.zoneID === state.searchBeanModal.zoneIdList[0];
      })) === null || _f === void 0 ? void 0 : _f.zoneURL;
    }
    //Handling the districtUrl and districtId
    else if (isSingleDistrictSelected.value) {
      state.searchBeanModal.districtURL = district.zoneURL;
      state.searchBeanModal.districtId = district.districtID;
    } else {
      state.searchBeanModal.districtURL = null;
      state.searchBeanModal.districtId = null;
    }
    updatePlaceNameAction();
  };
  var removeDistrict = function removeDistrict(zone, updatePlaceNameAction, district) {
    var _a, _b, _c;
    if (!(Object.keys(state.districtSelected).length > 0) && !areAllDistrictsSelected(zone.zoneID)) {
      return;
    }
    if (district) {
      //Removing the zone url and id since the districtIds will be inserted in the url
      state.searchBeanModal.zoneId = null;
      state.searchBeanModal.zoneURL = null;
      //By default, we will also remove the districts URL and id
      state.searchBeanModal.districtURL = null;
      state.searchBeanModal.districtId = null;
      if (!state.districtSelected[zone.zoneID]) {
        //In this scenario the district of the selected zone are all selected just visibly...
        //... which means that the districtObj is empty for that given zoneId
      } else {
        state.districtSelected[zone.zoneID].splice(state.districtSelected[zone.zoneID].indexOf(district.districtID), 1);
      }
      if (state.searchBeanModal.districtIdList)
        //Removing the districtId from the array
        state.searchBeanModal.districtIdList = _toConsumableArray(state.searchBeanModal.districtIdList.filter(function (districtId) {
          return district.districtID !== districtId;
        }));
      updatePlaceNameAction();
      /*
      * Case: zone with all districts selected
      *   1) zoneId will be removed
      *   2) remaining district will be added
      * */
      if (areAllDistrictsSelected(zone.zoneID)) {
        removeZone(zone, function () {
          console.log("");
        }, true);
        var districtsToAdd = state.districtsObj[district.zoneID].filter(function (districtToAdd) {
          return districtToAdd.districtID !== district.districtID;
        }).map(function (d) {
          return d.districtID;
        });
        if (state.searchBeanModal.districtIdList) state.searchBeanModal.districtIdList = [].concat(_toConsumableArray(state.searchBeanModal.districtIdList), _toConsumableArray(districtsToAdd));
        state.districtSelected[zone.zoneID] = districtsToAdd;
        updatePlaceNameAction();
        return;
      }
      /**
       * Case: There is one zone with districts selected
       * */
      if (Object.keys(state.districtSelected).length === 1) {
        /*Case: There is only one district in the selected zone */
        if (Object.values(state.districtSelected)[0].length === 1) {
          var lastDistrict = state.districtsObj[zone.zoneID].find(function (district) {
            return district.districtID === state.districtSelected[zone.zoneID][0];
          });
          state.searchBeanModal.districtURL = lastDistrict === null || lastDistrict === void 0 ? void 0 : lastDistrict.zoneURL;
          state.searchBeanModal.districtId = lastDistrict === null || lastDistrict === void 0 ? void 0 : lastDistrict.districtID;
          updatePlaceNameAction();
        }
      }
      /*
      * Case: Zone without districts
      * */
      if (!getDistrictSelectedLengthByZoneId(zone.zoneID)) {
        state.searchBeanModal.districtURL = null;
        state.searchBeanModal.districtId = null;
        if (state.searchBeanModal.zoneId || ((_a = state.searchBeanModal.zoneIdList) === null || _a === void 0 ? void 0 : _a.length) === 1) state.searchBeanModal.zoneURL = zone.zoneURL;
        // $delete(state.districtSelected, zone.zoneID)
        delete state.districtSelected[zone.zoneID];
        removeZone(zone, updatePlaceNameAction, true);
        //Removing all the
      }
      /*
      * Case: One zone selected with other districts selected too
      * */
      if (state.searchBeanModal.zoneIdList && state.searchBeanModal.zoneIdList.length === 1 || state.searchBeanModal.zoneId) {
        // @ts-ignore
        state.searchBeanModal.zoneURL = (_b = state.zoneList.find(function (z) {
          return z.zoneID === state.searchBeanModal.zoneIdList[0];
        })) === null || _b === void 0 ? void 0 : _b.zoneURL;
      }
    }
    //Not a district
    else {
      var districtsToRemove = state.districtSelected[zone.zoneID];
      // $delete(state.districtSelected, zone.zoneID)
      delete state.districtSelected[zone.zoneID];
      if (isSingleDistrictSelected.value) {
        var _Object$entries$ = _slicedToArray(Object.entries(state.districtSelected)[0], 2),
          zoneId = _Object$entries$[0],
          districtIds = _Object$entries$[1];
        var lastSingleDistrict = state.districtsObj[+zoneId].find(function (district) {
          return district.districtID === districtIds[0];
        });
        state.searchBeanModal.districtURL = lastSingleDistrict === null || lastSingleDistrict === void 0 ? void 0 : lastSingleDistrict.zoneURL;
        state.searchBeanModal.districtId = lastSingleDistrict === null || lastSingleDistrict === void 0 ? void 0 : lastSingleDistrict.districtID;
      }
      if (districtsToRemove) state.searchBeanModal.districtIdList = ((_c = state.searchBeanModal.districtIdList) === null || _c === void 0 ? void 0 : _c.filter(function (districtId) {
        return !districtsToRemove.includes(districtId);
      })) || [];
      updatePlaceNameAction();
    }
  };
  return Object.assign(Object.assign({}, toRefs(state)), {
    //Computed
    isSingleDistrictSelected: isSingleDistrictSelected,
    isAnyDistrictSelected: isAnyDistrictSelected,
    selectedDistrictLength: selectedDistrictLength,
    partialSelectedDistrictLength: partialSelectedDistrictLength,
    allDistrictSelectedPerZone: allDistrictSelectedPerZone,
    //Methods
    convertEnergyClassFilter: convertEnergyClassFilter,
    convertFloor: convertFloor,
    resetSearchBeanZonesAndLocalities: resetSearchBeanZonesAndLocalities,
    updateSearchModal: updateSearchModal,
    updateSearchModalByPlace: updateSearchModalByPlace,
    updateSearchModalAndPlace: updateSearchModalAndPlace,
    fixSearchBean: fixSearchBean,
    initZonesAndLocalities: initZonesAndLocalities,
    areAllDistrictsSelected: areAllDistrictsSelected,
    isSingleDistrictByZoneId: isSingleDistrictByZoneId,
    isZoneOrLocalitySelected: isZoneOrLocalitySelected,
    isZoneWithoutDistrict: isZoneWithoutDistrict,
    areZonesAndLocalitiesEmpty: areZonesAndLocalitiesEmpty,
    areZonesAndLocalitiesFilled: areZonesAndLocalitiesFilled,
    getSingleSelectedZone: getSingleSelectedZone,
    getSingleSelectedDistrict: getSingleSelectedDistrict,
    getZoneById: getZoneById,
    getDistrictById: getDistrictById,
    getDistrictLengthByZoneId: getDistrictLengthByZoneId,
    getDistrictSelectedLengthByZoneId: getDistrictSelectedLengthByZoneId,
    resetZoneAndLocalities: resetZoneAndLocalities,
    addZone: addZone,
    removeZone: removeZone,
    isZoneSelected: isZoneSelected,
    isLocationSelected: isLocationSelected,
    isDistrictSelected: isDistrictSelected,
    addLocation: addLocation,
    removeLocation: removeLocation,
    insertDistrictByZoneId: insertDistrictByZoneId,
    insertBulkDistrictByZoneId: insertBulkDistrictByZoneId,
    onPlaceLIClick: onPlaceLIClick,
    onDistrictClick: onDistrictClick,
    addDistrict: addDistrict,
    removeDistrict: removeDistrict
  });
}